import { render, staticRenderFns } from "./table-small-b1.vue?vue&type=template&id=62ea4ea8&scoped=true&"
import script from "./table-small-b1.vue?vue&type=script&lang=js&"
export * from "./table-small-b1.vue?vue&type=script&lang=js&"
import style0 from "./table-small-b1.vue?vue&type=style&index=0&id=62ea4ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ea4ea8",
  null
  
)

export default component.exports